/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBlocks.defs.js'
export { main as default } from './getBlocks.defs.js'
